import * as svg from "../../../assets/download-icon.svg";

import {iconBuilder} from "./iconBuilder";

const DownloadIcon = iconBuilder(svg, "DownloadIcon", "0 0 12 12");

export default DownloadIcon;
